<template>
  <div class="mt-res-download-options">
    <div class="mt-res-download-options__option">
      <div class="mt-res-download-options__option-title">
        <div class="mt-res-download-options__option-logo">
          <svg
              class="mt-res-download-options__option-logo-icon"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M7.24434 0.375L8.82767 1.95833H15.6249C15.8349 1.95833 16.0362 2.04174 16.1847 2.19021C16.3332 2.33867 16.4166 2.54004 16.4166 2.75V13.8333C16.4166 14.0433 16.3332 14.2447 16.1847 14.3931C16.0362 14.5416 15.8349 14.625 15.6249 14.625H1.37492C1.16496 14.625 0.963592 14.5416 0.815126 14.3931C0.666659 14.2447 0.583252 14.0433 0.583252 13.8333V1.16667C0.583252 0.956704 0.666659 0.75534 0.815126 0.606874C0.963592 0.458407 1.16496 0.375 1.37492 0.375H7.24434ZM13.2499 12.25H10.0833V9.875H11.6666V8.29167H10.0833V6.70833H11.6666V5.125H10.0833V3.54167H8.17217L6.58884 1.95833H2.16659V13.0417H14.8333V3.54167H11.6666V5.125H13.2499V6.70833H11.6666V8.29167H13.2499V12.25Z"
                fill="white"
            ></path>
          </svg>
        </div>
        <div class="mt-res-download-options__option-title-text">PDF</div>
      </div>
      <svg
          class="mt-res-download-options__option-action"
          width="17"
          height="15"
          viewBox="0 0 17 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="download({ format: 'pdf' })"
      >
        <path
            d="M9.29159 5.91667H13.2499L8.49992 10.6667L3.74992 5.91667H7.70825V0.375H9.29159V5.91667ZM2.16659 13.0417H14.8333V7.5H16.4166V13.8333C16.4166 14.0433 16.3332 14.2447 16.1847 14.3931C16.0362 14.5416 15.8349 14.625 15.6249 14.625H1.37492C1.16496 14.625 0.963592 14.5416 0.815126 14.3931C0.666659 14.2447 0.583252 14.0433 0.583252 13.8333V7.5H2.16659V13.0417Z"
            fill="#00788C"
        />
      </svg>
    </div>
    <div class="mt-res-download-options__option">
      <div class="mt-res-download-options__option-title">
        <div class="mt-res-download-options__option-logo">
          <svg
              class="mt-res-download-options__option-logo-icon"
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M12.4583 15.0416H14.8333V3.9583H12.4583V2.37497H15.625C15.8349 2.37497 16.0363 2.45837 16.1848 2.60684C16.3332 2.75531 16.4166 2.95667 16.4166 3.16663V15.8333C16.4166 16.0433 16.3332 16.2446 16.1848 16.3931C16.0363 16.5416 15.8349 16.625 15.625 16.625H12.4583V15.0416ZM1.26335 2.27759L11.2146 0.85655C11.2708 0.848494 11.328 0.852604 11.3824 0.868603C11.4369 0.884603 11.4872 0.912116 11.5301 0.94928C11.573 0.986444 11.6073 1.03239 11.6309 1.084C11.6545 1.13561 11.6667 1.19169 11.6666 1.24843V17.7515C11.6666 17.8082 11.6545 17.8642 11.631 17.9157C11.6074 17.9673 11.5731 18.0132 11.5304 18.0503C11.4876 18.0875 11.4373 18.115 11.383 18.1311C11.3286 18.1471 11.2715 18.1513 11.2154 18.1434L1.26256 16.7223C1.07384 16.6955 0.901159 16.6014 0.776231 16.4574C0.651304 16.3134 0.582521 16.1292 0.58252 15.9386V3.06134C0.582521 2.87072 0.651304 2.6865 0.776231 2.54252C0.901159 2.39854 1.07384 2.30447 1.26256 2.27759H1.26335ZM2.16664 3.74851V15.2514L10.0833 16.3827V2.61722L2.16664 3.74851ZM7.70831 6.3333H9.29165V12.6666H7.70831L6.12498 11.0833L4.54164 12.6666H2.95831V6.3333H4.54164L4.54956 10.2916L6.12498 8.7083L7.70831 10.2829V6.3333Z"
                fill="white"
            ></path>
          </svg>
        </div>
        <div class="mt-res-download-options__option-title-text">DOCX</div>
      </div>
      <svg
          class="mt-res-download-options__option-action"
          width="17"
          height="15"
          viewBox="0 0 17 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="download({ format: 'docx' })"
      >
        <path
            d="M9.29159 5.91667H13.2499L8.49992 10.6667L3.74992 5.91667H7.70825V0.375H9.29159V5.91667ZM2.16659 13.0417H14.8333V7.5H16.4166V13.8333C16.4166 14.0433 16.3332 14.2447 16.1847 14.3931C16.0362 14.5416 15.8349 14.625 15.6249 14.625H1.37492C1.16496 14.625 0.963592 14.5416 0.815126 14.3931C0.666659 14.2447 0.583252 14.0433 0.583252 13.8333V7.5H2.16659V13.0417Z"
            fill="#00788C"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {

  },
  data: () => ({
    rr: false,
  }),
  computed: {},

  watch: {},
  methods: {
    /* GETTERS */
    /* SETTERS */

    /* HANDLERS */
    download({format,}) {
      this.$emit('download', {format,});
    },

    /* HELPERS */
  },

  created() {
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.mt-res-download-options {
  margin-top: 20px;

  &__option {
    font-family: 'Mulish';
    font-style: normal;
    border: 1.5px solid #DFE0EB;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    margin-top: 5px;

    &:first-child {
      margin-top: 0;
    }

    &-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #000000;
      user-select: none;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;

      &-text {
        margin-left: 15px;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.15px;
        color: #000000;
        cursor: pointer;
      }
    }

    &-logo {
      background: #00788C;
      border-radius: 2px;
      width: 31px;
      height: 31px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;

      &-icon {
      }
    }

    &-action {
      cursor: pointer;
    }
  }
}
</style>